import React from "react";

import { useQueryString } from "app/context";
import { select } from "app/utils";

import FilterAccordian from "components/common/FilterAccordian";
import FilterTag from "components/common/FilterTag";
import ListItem from "components/filters/ListItem";

const QueryStringListClear = ({ label, queryKey }) => {
  const { queryString, onClearQueryStringKey } = useQueryString();

  return (
    <ListItem
      label={label}
      onClick={() => onClearQueryStringKey(queryKey)}
      active={!queryString[queryKey]}
    />
  );
};

const QueryStringListItem = ({ label, value, queryKey }) => {
  const { queryString, onToggleQueryStringValue } = useQueryString();
  let cleanedQueryString = [];
  if (queryString[queryKey]) {
    cleanedQueryString = queryString[queryKey].map(actualUri => decodeURI(actualUri));
  }

  return (
    <ListItem
      label={label}
      onClick={() => onToggleQueryStringValue(queryKey, value, true)}
      active={cleanedQueryString && cleanedQueryString.includes(value)}
    />
  );
};

const QueryStringList = ({ clearLabel, initialOpen, options, queryKey, title }) => (
  <FilterAccordian initialOpen={initialOpen} title={title}>
    <ul>
      <QueryStringListClear label={clearLabel} queryKey={queryKey} />
      {Object.keys(options).map(key => (
        <QueryStringListItem
          key={key}
          label={options[key]}
          value={key}
          queryKey={queryKey}
        />
      ))}
    </ul>
  </FilterAccordian>
);

export const QueryStringListState = ({ options, queryKey }) => {
  const { queryString, onToggleQueryStringValue } = useQueryString();

  if (!queryString[queryKey]) {
    return null;
  }

  const cleanedQueryString = queryString[queryKey].map(actualUri => decodeURI(actualUri));
  return (
    <>
      {cleanedQueryString.map(value => (
        <FilterTag
          key={value}
          label={select(value, options)}
          onRemove={() => onToggleQueryStringValue(queryKey, value)}
        />
      ))}
    </>
  );
};

export default QueryStringList;
